<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="false" :dateRangeMenu="false">
            <template slot="leftSide">
              <hierarchy-menu @on-selected="onSelectedDevice"></hierarchy-menu>
            </template>
          </graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <slide-y-up-transition>
            <md-table v-show="!showEmpty" v-model="relaysList" table-header-color="green">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID">{{ item.relayID }}</md-table-cell>
                <md-table-cell :md-label="$lang.general.name">
                  <md-field v-if="item.edited" style="width:125px;">
                    <md-input
                      :value="item.name"
                      v-focus
                      v-on:keyup.enter="submitEditedForm(item, $event.target.value)"
                      v-on:dblclick="showEditForm(item)"
                    ></md-input>
                  </md-field>
                  <span
                    v-else
                    v-on:dblclick="showEditForm(item)"
                    style="cursor: pointer;"
                  >{{ item.name }}</span>
                </md-table-cell>
                <md-table-cell :md-label="$lang.general.device">{{ item.disconnectorName }}</md-table-cell>

                <md-table-cell :md-label="$lang.general.energy_consumption">
                  <animated-number
                    :value="item.energy"
                    :formatValue="energyFormat"
                    :duration="1000"
                  />
                </md-table-cell>
                <md-table-cell :md-label="$lang.general.status">
                  <md-button
                    class="md-button md-simple md-just-icon"
                    :class="{'md-primary':item.state == true, 'md-danger':item.state == false}"
                    :disabled="!deviceStatus(item.deviceMAC)"
                    @click="setRelay(item)"
                  >
                    <md-icon v-if="item.state == true" :title="$lang.tooltip.power_on">power</md-icon>
                    <md-icon v-if="item.state == false" :title="$lang.tooltip.power_off">power_off</md-icon>
                  </md-button>

                  <!-- <md-icon class="md-primary" v-if="item.state == true">power</md-icon>
                  <md-icon class="md-info" v-if="item.state == false">power_off</md-icon>-->
                </md-table-cell>

                <md-table-cell>
                  <md-button
                    :title="writeTitle(item.state)"
                    class="md-info md-simple md-just-icon"
                    :disabled="!deviceStatus(item.deviceMAC)"
                    @click="setRelay(item)"
                  >
                    <md-icon>power_settings_new</md-icon>
                  </md-button>

                  <md-button
                    :title="$lang.tooltip.settings"
                    class="md-simple md-just-icon"
                    @click="modalOpen(item)"
                  >
                    <md-icon>settings</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </slide-y-up-transition>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <slide-y-up-transition :duration="200">
        <md-empty-state
          v-show="showEmpty"
          md-icon="check_box_outline_blank"
          :md-label="$lang.titles.no_disconnector_selected"
          :md-description="$lang.messages.choose_disconnector_menu"
        ></md-empty-state>
      </slide-y-up-transition>
    </div>

    <modal v-if="showModal" @close="modalClose()">
      <template slot="header">
        <h4 class="modal-title">{{modalData.header}}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="modalClose()"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.general.name}}</label>
              <md-input
                v-model="modalData.name"
                pattern=".{3,}"
                maxlength="30"
                @keyup.enter="modalSave()"
                type="text"
                ref="editName"
              ></md-input>
            </md-field>
          </div>
        </div>
        <br />
        <br />
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field>
              <label>{{$lang.charts.active_power}}</label>
              <md-input
                v-model="modalData.power"
                pattern="[0-9]+"
                @keyup.enter="modalSave()"
                type="text"
                :disabled="!deviceStatus(modalData.deviceMAC)"
              ></md-input>
              <span class="md-suffix">W</span>
            </md-field>
          </div>
        </div>
        <br />
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="modalSave()">{{$lang.keys.save}}</md-button>
        <md-button
          class="md-danger"
          @click="modalDeleteEnergy()"
          :disabled="!deviceStatus(modalData.deviceMAC)"
        >{{$lang.keys.delete_energy}}</md-button>
        <md-button class="md-simple" @click="modalClose()">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import HierarchyMenu from "./components/HierarchyMenu";
import graphToolBar from "@/components/GraphToolBar";
import { Modal } from "@/components";
import axios from "axios";
import snackBar from "@/components/SnackBar";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import pieChartOptions from "@/config/charts/pie";
import AnimatedNumber from "animated-number-vue";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  directives: { focus },
  components: {
    HierarchyMenu,
    "snack-bar": snackBar,
    graphToolBar,
    AnimatedNumber,
    SlideYUpTransition,
    Modal
  },

  data() {
    return {
      relaysList: [],
      devicesList: null,
      showEmpty: true,
      modalData: {},
      showModal: false
    };
  },

  computed: {
    WSPayload() {
      return this.$store.getters.getPayload;
    },
    isConnected() {
      return this.$store.getters.isConnected;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },

  watch: {
    WSPayload: function(payload, oldPayload) {
      const relayListLen = this.relaysList.length;

      if (relayListLen > 0) {
        for (let index = 0; index < relayListLen; index++) {
          if (this.relaysList[index].deviceMAC === payload.device) {
            this.relaysList[index].state =
              payload.data["relay_" + this.relaysList[index].relayID];
            this.relaysList[index].energy =
              payload.data.energy["R" + this.relaysList[index].relayID];
          }
        }
      }
    },
    isConnected: function(newStatus, oldStatus) {
      if (newStatus) {
        this.devicesList.forEach(element => {
          const wsActionMessage = {
            deviceToken: getSelectedDeviceToken(element.data.mac),
            data: true
          };
          this.$socket.send(JSON.stringify(wsActionMessage));
        });
      }
    }
  },

  created() {
    this.$store.commit("setLoading", true);
  },

  methods: {
    onSelectedDevice(devices) {
      this.devicesList = devices;
      const devicesLen = devices.length;

      if (devicesLen > 0) {
        devices.forEach((element, index) => {
          if (this.isConnected) {
            const wsActionMessage = {
              deviceToken: getSelectedDeviceToken(element.data.mac),
              data: true
            };
            this.$socket.send(JSON.stringify(wsActionMessage));
          }

          this.getRelaysNames(element.title, element.data.mac);

          if (index === devicesLen - 1) {
            this.showEmpty = false;
            setTimeout(() => {
              this.$store.commit("setLoading", false);
            }, 300);
          }
        });
      } else {
        this.relaysList = [];
        this.showEmpty = true;
        this.$store.commit("setLoading", false);
      }
    },

    showEditForm(item) {
      item.edited = !item.edited;

      this.relaysList.forEach(relay => {
        if (
          relay.deviceMAC != item.deviceMAC ||
          relay.relayID != item.relayID
        ) {
          relay.edited = false;
        }
      });
    },

    submitEditedForm(item, newValue) {
      let postData = {
        token: getSelectedDeviceToken(item.deviceMAC),
        names: {}
      };

      postData.names["R" + item.relayID] = newValue;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/disconnector/settings",
        data: postData,
        withCredentials: true
      })
        .then(response => {
          item.name = newValue;
          item.edited = false;
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    modalOpen(item) {
      this.modalData = {
        deviceMAC: item.deviceMAC,
        header:
          item.disconnectorName +
          " | " +
          this.$lang.charts.relay +
          " " +
          item.relayID,
        relayID: item.relayID,
        name: item.name,
        power: item.power
      };
      this.showModal = true;

      this.$nextTick(() => {
        this.$refs.editName.$el.focus();
      });
    },

    modalClose() {
      this.showModal = false;
    },

    modalSave() {
      let postData = {
        token: getSelectedDeviceToken(this.modalData.deviceMAC),
        names: {}
      };

      postData.names["R" + this.modalData.relayID] = this.modalData.name;
      if (this.deviceStatus(this.modalData.deviceMAC)) {
        postData.power = {};
        postData.power["R" + this.modalData.relayID] = this.modalData.power;
      }

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/disconnector/settings",
        data: postData,
        withCredentials: true
      })
        .then(response => {
          const relayListIndex = this.relaysList.findIndex(
            relay =>
              relay.deviceMAC === this.modalData.deviceMAC &&
              relay.relayID === this.modalData.relayID
          );

          if (relayListIndex !== -1) {
            this.relaysList[relayListIndex].name = this.modalData.name;
            if (postData.power) {
              this.relaysList[relayListIndex].power = this.modalData.power;
            }
          }

          this.$refs.snackbar.notify(
            this.$lang.messages.settings_successfully_saved
          );
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });

      this.modalClose();
    },

    modalDeleteEnergy() {
      let postData = {
        token: getSelectedDeviceToken(this.modalData.deviceMAC),
        clear_energy: {}
      };

      postData.clear_energy["R" + this.modalData.relayID] = true;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/disconnector/settings",
        data: postData,
        withCredentials: true
      })
        .then(response => {
          this.$refs.snackbar.notify(this.$lang.messages.delete_energy_succes);
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });

      this.modalClose();
    },

    energyFormat(value) {
      if (value > 100000) {
        return `${Number(value / 1000).toFixed(2)} kWh`;
      } else {
        return `${Number(value).toFixed(2)} Wh`;
      }
    },

    writeTitle(state) {
      if (state) {
        return this.$lang.keys.turn_off;
      }
      return this.$lang.keys.turn_on;
    },

    deviceStatus(deviceMAC) {
      try {
        const deviceListIndex = this.deviceList.findIndex(
          e => e.mac == deviceMAC
        );
        if (this.deviceList[deviceListIndex].status === "ONLINE") {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    setRelay(relay) {
      let data = {
        token: getSelectedDeviceToken(relay.deviceMAC)
      };
      data["relay_" + relay.relayID] = !relay.state;

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/disconnector/set-relay",
        data: data,
        withCredentials: true
      })
        .then(response => {})
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    getRelaysNames(disconnectorName, deviceMAC) {
      this.relaysList = [];

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(deviceMAC),
          names: true,
          power: true
        },
        withCredentials: true
      })
        .then(response => {
          for (let i = 1; i <= 4; i++) {
            const relay = {
              disconnectorName: disconnectorName,
              deviceMAC: deviceMAC,
              relayID: i,
              name: response.data.data["R" + i].name,
              power: response.data.data["R" + i].power,
              state: false,
              energy: 0,
              edited: false
            };
            this.relaysList.push(relay);
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              for (let i = 1; i <= 4; i++) {
                const relay = {
                  disconnectorName: disconnectorName,
                  deviceMAC: deviceMAC,
                  relayID: i,
                  name: this.$lang.charts.relay + " " + i,
                  power: 0,
                  state: false,
                  energy: 0,
                  edited: false
                };
                this.relaysList.push(relay);
              }
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    }
  },

  beforeDestroy() {
    if (this.isConnected) {
      this.devicesList.forEach(element => {
        const wsActionMessage = {
          deviceToken: getSelectedDeviceToken(element.data.mac),
          data: false
        };
        this.$socket.send(JSON.stringify(wsActionMessage));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>